import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Select, HomeIcon } from 'src/components';

import styles from './SubHeader.module.scss';

export const SubHeader = ({ title, data, filter }) => {
	return (
		<div className={styles.subHeader}>
			<span className={styles.spanClass}>
				<a href={'/'} className={styles.homeIconButton}>
					<HomeIcon className={styles.homeIcon} />
				</a>
				<span className={clsx(styles.title)}> {title}</span>
			</span>
			<span className={styles.plantDropdown}>
				<Select options={data} onChange={filter} />
			</span>
		</div>
	);
};

SubHeader.propTypes = {
	title: PropTypes.string.isRequired,
};
